export const isNotNull = <T>(value: T): value is NonNullable<T> => value != null

export const isNotNullKey = <T, Key extends keyof T>(key: Key) => (
  value: T,
): value is T & Record<Key, NonNullable<T[Key]>> => value && value[key] != null
